import type { LocalizedTextDto } from '@/api/generated';

export type WidgetLang = 'en' | 'el';

/**
 * Normalize i18next language code to widget locale ('en' | 'el').
 */
export function getWidgetLang(language: string): WidgetLang {
  return language.split('-')[0] === 'el' ? 'el' : 'en';
}

/**
 * Pick display text from a locale map for the guest's selected language,
 * falling back to the other locale when the primary is empty.
 */
export function pickLocalizedText(
  map: LocalizedTextDto | null | undefined,
  lang: WidgetLang,
): string | null {
  if (!map) return null;
  const primary = (map[lang] ?? '').trim();
  if (primary) return primary;
  const other = lang === 'en' ? map.el : map.en;
  const fallback = (other ?? '').trim();
  return fallback || null;
}
